import styles from '../styles.module.scss';
import skeleton from './styles.module.scss';

export default function BonusClaimRewardModalContentHeaderSkeleton() {
  return (
    <div className={styles.card}>
      <div className={styles.card__column}>
        <div className={skeleton.date} />
        <div className={skeleton.label} />
        <div className={skeleton.value} />
      </div>
    </div>
  );
}
